// @ts-nocheck: converted from JS

import { FormField } from '@/components/UI/FormFields';
import { getRegisterConfig } from '@/components/UI/FormFields/FormField.utils';
import ReactSelect from '@/components/UI/Select';
import { _isNotEmpty, _notNil, safelyDecodeURIComponent } from '@/littledash';
//@ts-expect-error - old hook form - replace with `react-hook-form-latest`
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form';
import { MetaDataType } from '@/model/Metadata.model';
import '@/components/Metadata/Fieldtypes/MetadataFields.scss';

interface SelectProps {
  value?: any;
  options?: any;
  name?: any;
  label?: any;
  isMulti?: any;
  disabled?: any;
  hint?: any;
  required?: any;
  overrideLabel?: any;
  testId?: any;
  metadataType?: MetaDataType;
}

const Select: FC<SelectProps> = ({
  value,
  options,
  name,
  label,
  isMulti,
  disabled = false,
  hint,
  required,
  overrideLabel,
  testId = 'select',
  metadataType,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const handleChange = (onChange, data) => {
    if (data) {
      if (isMulti) {
        onChange(JSON.stringify(data.map((d) => d.value)));
      } else {
        onChange(data.value);
      }
    } else {
      onChange('');
    }
  };

  const getLabelFromOptions = (value) => options.find((option) => option.value === value)?.label || undefined;

  const asSelectValue = (value) => {
    if (_isNotEmpty(value)) {
      if (isMulti) {
        const options = typeof value === 'string' ? JSON.parse(value) : value;
        return options?.map((v) => ({
          label: safelyDecodeURIComponent(v),
          value: v,
        }));
      }
      return {
        label: overrideLabel ?? getLabelFromOptions(value),
        value,
      };
    }
    return undefined;
  };

  return (
    <FormField name={name} label={label} hint={hint} required={required} testPrefix={testId}>
      <div className={metadataType === 'study_meta' ? 'metadata-select-container' : ''}>
        <Controller
          defaultValue={value}
          name={name}
          rules={getRegisterConfig({ required })}
          control={control}
          render={({ onChange, value }: ControllerRenderProps) => (
            <ReactSelect
              defaultValue={asSelectValue(value)}
              options={options}
              isMulti={isMulti}
              onChange={(data) => handleChange(onChange, data)}
              disabled={disabled}
              className={_notNil(name) && _notNil(errors[name]) ? 'input__error' : ''}
            />
          )}
        />
      </div>
    </FormField>
  );
};

export default Select;
